import React from "react";
import PropTypes from "prop-types";
import Image from "../../elements/image";
import "./style.scss";

const GearOrderItem = ({ image, name, details, priceFormatted, discountPriceFormatted }) => {
  return (
    <div className="gear-order-item" key={name}>
      <div className="gear-order-item__image">
        <Image {...image} />
      </div>
      <div className="gear-order-item__data">
        <span className="gear-order-item__name">{name}</span>
        <ul className="gear-order-item__details">
          {details.map((detail, index) => {
            return (
              <li key={index} className="gear-order-item__details-item">
                {detail.label}: {detail.value}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="gear-order-item__price">
        <span>{discountPriceFormatted || priceFormatted}</span>
        {discountPriceFormatted && <span className="gear-order-item__price--original">{priceFormatted}</span>}
      </div>
    </div>
  );
};

GearOrderItem.propTypes = {
  image: PropTypes.shape(Image.propTypes).isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  priceFormatted: PropTypes.string.isRequired,
  discountPriceFormatted: PropTypes.string
};

export default GearOrderItem;
